module.exports = __webpack_public_path__ + "img/icon_play_w.46717c4a.svg";